import httpClient from '../httpClient';


const getContactInfo =  () => httpClient.get('/MainPage/ContactInf/Get/1').then(
  (data) => data
)
  .catch((e)=>{
  })
const setContactInfo =  (params) => httpClient.post('/MainPage/ContactInf', {
  customerServiceNo: params.customerServiceNo,
  email:  params.email
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } }).then((data)=>data)
  .catch(()=>{
    //
  })
const putContactInfo = (params,id) => httpClient.put(`/MainPage/ContactInf/PUT/${1}`, {
  id:1,
  customerServiceNo: params.customerServiceNo,
  email:  params.email
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const  deleteContactInfo= (id) => httpClient.delete(`/MainPage/ContactInf/Delete/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

export {
  getContactInfo,
  setContactInfo,
  putContactInfo,
  deleteContactInfo
  // getUser,
  // createUser
}
